import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.tag', {
      wrapper: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 12,
        lineHeight: 1,
        borderRadius: 'control',
        padding: '5px 8px',
        mr: 'x',
      },
      wrapperVariant: composeStyle.switch('variant')
        .case('outline', {
          bg: 'white',
          color: composeStyle.var('modifier', 'palette._VAR_.base'),
          fill: composeStyle.var('modifier', 'palette._VAR_.base'),
          border: 1,
          borderRadius: 'control',
          borderStyle: 'outline',
          borderColor: composeStyle.var('modifier', 'palette._VAR_.base'),
          '&:hover:not([data-disable="true"])': {
            borderColor: composeStyle.var('modifier', 'palette._VAR_.hover'),
            color: composeStyle.var('modifier', 'palette._VAR_.hover'),
            fill: composeStyle.var('modifier', 'palette._VAR_.hover'),
          },
          '&[data-disable="true"]': {
            cursor: 'not-allowed',
            borderColor: composeStyle.var('modifier', 'palette._VAR_.disable'),
            color: composeStyle.var('modifier', 'palette._VAR_.disable'),
            fill: composeStyle.var('modifier', 'palette._VAR_.disable'),
          },
        })
        .case('grey', {
          bg: '#F7F7F7',
          color: 'body',
          fill: 'body',
          '&:hover:not([data-disable="true"])': {
            bg: 'palette.grey3.base',
          },
          '&[data-disable="true"]': {
            cursor: 'not-allowed',
            color: 'ash',
            fill: 'ash',
          },
        })
        .case('fill', {
          bg: composeStyle.var('modifier', 'palette._VAR_.base'),
          color: '#fff',
          fill: '#fff',
          '&:hover:not([data-disable="true"])': {
            bg: composeStyle.var('modifier', 'palette._VAR_.hover'),
          },
          '&[data-disable="true"]': {
            bg: composeStyle.var('modifier', 'palette._VAR_.disable'),
          },
        }),
      text: {
        maxWidth: 80,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    }),
  ]
}
